exports = module.exports = require("../../../../node_modules/css-loader/lib/css-base.js")(undefined);
// imports


// module
exports.push([module.id, ".Media-local__media--NxPvc {\n  height: 8.75rem;\n  -webkit-box-shadow: 0px 4px 4px rgba(41, 57, 77, 0.3);\n          box-shadow: 0px 4px 4px rgba(41, 57, 77, 0.3);\n  background: -webkit-linear-gradient(60deg, rgba(41, 57, 77, 0.24) 0%, rgba(41, 57, 77, 0.545) 50%, rgba(41, 57, 77, 0.485) 50%, rgba(41, 57, 77, 0.425) 100%) #3c4e64;\n  background: -o-linear-gradient(60deg, rgba(41, 57, 77, 0.24) 0%, rgba(41, 57, 77, 0.545) 50%, rgba(41, 57, 77, 0.485) 50%, rgba(41, 57, 77, 0.425) 100%) #3c4e64;\n  background: linear-gradient(30deg, rgba(41, 57, 77, 0.24) 0%, rgba(41, 57, 77, 0.545) 50%, rgba(41, 57, 77, 0.485) 50%, rgba(41, 57, 77, 0.425) 100%) #3c4e64;\n  border-radius: 5px; }\n", ""]);

// exports
exports.locals = {
	"media": "Media-local__media--NxPvc"
};


//////////////////
// WEBPACK FOOTER
// ./node_modules/css-loader?{"modules":true,"localIdentName":"[name]__[local]--[hash:base64:5]","importLoaders":1}!./node_modules/postcss-loader/lib?{"ident":"postcss","plugins":[null,null]}!./node_modules/sass-loader/lib/loader.js?{"includePaths":["/home/runner/work/media/media/src","node_modules/foundation-sites/scss","node_modules/motion-ui/src"]}!./src/components/Common/MediaFetching/Media.local.scss
// module id = 426
// module chunks = 0